import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const brandmasterAdapter = createEntityAdapter({})

const initialState = brandmasterAdapter.getInitialState()

export const brandmasterApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getbrandmaster: builder.query({
            query: () => ({
                url: '/brandmaster',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedbrandmaster = responseData.map(brandmaster => {
                    // console.log(brandmaster)
                    brandmaster.id = brandmaster._id
                    // console.log(brandmaster)
                    return brandmaster
                });
                return brandmasterAdapter.setAll(initialState, loadedbrandmaster)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'BRANDMASTER', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'BRANDMASTER', id }))
                    ]
                } else return [{ type: 'BRANDMASTER', id: 'LIST' }]
            }
        }),
        addNewbrandmaster: builder.mutation({
            query: initialUserData => ({
                url: '/brandmaster',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'BRANDMASTER', id: "LIST" }
            ]
        }),
        addBulkbrandmaster: builder.mutation({
            query: initialUserData => {
                console.log("RTK Query - Data being sent:", initialUserData);
                console.log("RTK Query - Data type:", typeof initialUserData);
                console.log("RTK Query - Is array:", Array.isArray(initialUserData));
                
                // Ensure data is an array
                const dataToSend = Array.isArray(initialUserData) ? initialUserData : Object.values(initialUserData);
                console.log("RTK Query - Final data to send:", dataToSend);
                
                return {
                    url: '/brandmaster/addbulk',
                    method: 'POST',
                    body: dataToSend,
                }
            },
            invalidatesTags: [
                { type: 'BRANDMASTER', id: "LIST" }
            ]
        }),
        updatebrandmaster: builder.mutation({
            query: initialUserData => ({
                url: '/brandmaster',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'BRANDMASTER', id: arg.id }
            ]
        }),        
        deletebrandmaster: builder.mutation({
            query: ({ id }) => ({
                url: `/brandmaster`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'BRANDMASTER', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetbrandmasterQuery,
    useAddNewbrandmasterMutation,
    useAddBulkbrandmasterMutation,
    useUpdatebrandmasterMutation,
    useDeletebrandmasterMutation, 
} = brandmasterApiSlice

// returns the query result object
export const selectbrandmasterResult = brandmasterApiSlice.endpoints.getbrandmaster.select()

// creates memoized selector
const selectbrandmasterData = createSelector(
    selectbrandmasterResult,
    brandmasterResult => brandmasterResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllbrandmaster,
    selectById: selectbrandmasterById,
    selectIds: selectbrandmasterIds
    // Pass in a selector that returns the users slice of state
} = brandmasterAdapter.getSelectors(state => selectbrandmasterData(state) ?? initialState)